import { render, staticRenderFns } from "./NavPage.vue?vue&type=template&id=92b5a80e&scoped=true"
import script from "./NavPage.vue?vue&type=script&lang=js"
export * from "./NavPage.vue?vue&type=script&lang=js"
import style0 from "./NavPage.vue?vue&type=style&index=0&id=92b5a80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b5a80e",
  null
  
)

export default component.exports